jQuery(function ($) {
  const convertToRem = (px) => `${px / 16}rem`;

  const $html = $('html');
  const $header = $('.header');
  const $logo = $('.header__site-logo');

  const updateLayoutVars = () => {
    // Get the height of the header
    if ($header.length) {
      const headerHeight = $header[0].getBoundingClientRect().height;
      $html.css('--header-height', convertToRem(headerHeight));
    }

    // Get the distance between the left edge of the logo and the left edge of the page
    // The header is chosen because it is there in every page
    if ($logo.length) {
      const pageMargin = $logo[0].getBoundingClientRect().left;
      $html.css('--page-margin', convertToRem(pageMargin));
    }
  };

  updateLayoutVars();
  $(window).on('resize', updateLayoutVars);
});
